/* eslint no-implicit-coercion: "off" */

import { setTimeout } from "timers";

import $ from "jquery";

/* Polyfills */
import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/respimg/ls.respimg";
import "lazysizes/plugins/blur-up/ls.blur-up";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes";
import "../../styles/theme.scss";
import "../sections/sidecart";
// import '../sections/hover-intent';

import { focusHash, bindInPageLinks } from "@shopify/theme-a11y";

window.usersCurrentCountry = null;
window.productsToHide = [];
window.allProducts = [];
window.originalProductList = [];

window.getAllProducts = function(collection) {
  window.allProducts = Shopify.getAllProducts();
  window.originalProductList = window.allProducts;
};

// Common a11y fixes
focusHash();
bindInPageLinks();

/**
 * Simple function to set cookie
 * @param  {string} cname cookie name
 * @param  {string} value cookie value
 * @param  {number} exdays days until expiration 
 */
window.setCookie = (c_name, value, exdays) => {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var c_value = `${escape(value) +
    (exdays == null ? "" : `; expires=${exdate.toUTCString()}`)};path=/`;
  document.cookie = `${c_name}=${c_value}`;
};


/**
 * Simple function to get cookie
 * @param  {string} cname cookie name
 * @return {string} return cookie if exists, return empty string otherwise
 */
window.getCookie = (cname) => {
  var name = `${cname}=`;
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var cookie = ca[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
};


var redirectOrNot = function(country) {
  window.productsToHide.forEach((product) => {
      var productOnPage = $('#AjaxinateLoop').find(`#${product.product}`);

      if (!productOnPage.length) { return; }

      if (product.country === 'USA and CANADA' && (country === 'United States' || country === 'Canada' || country === 'US' || country == 'CA' || country == 'Puerto Rico' || country == 'PR')) {
      productOnPage.remove();
      } else if (product.country === 'EVERYWHERE ELSE' && (country !== 'United States' && country !== 'Canada' && country !== 'US' && country !== 'CA' && country !== 'Puerto Rico' && country !== 'PR')) {
      productOnPage.remove();
      }
  });
};

window.checkUsersCurrentCountry = function() {
  var countryIsoCode = window.getCookie('country_iso_code');

  if (countryIsoCode) {
      redirectOrNot(countryIsoCode)
      window.hideQuadPayOrNot(countryIsoCode)
  } else {
      setTimeout(() => {
      window.checkUsersCurrentCountry();
      }, 1222);
  }   
};

/** Heroku utility server endpoint */
var kfUtility = "https://kf-utility.herokuapp.com";

/** Storefront access token */
var SHOPIFY_STOREFRONT_ACCESS_TOKEN = `99e8f46136310b52aabca40a26a963ab`;

/** GraphQL endpoint */
var SHOPIFY_GRAPHQL_URI = `https://kf-apps.myshopify.com/api/graphql`;

/** Products GraphQL query */
var PRODUCTS = `
  query products($numProducts: Int!, $queryString: String!, $cursor: String) {
    products(first: $numProducts, query: $queryString, after: $cursor) {
      pageInfo {
        hasNextPage        
      }
      edges {
        cursor
        node {
          id
          title        
          handle
          tags
        }
      }
    }
  }`;

/**
 * Find products using query string
 *
 * @param {{ queryString: string }} { queryString }
 * @returns
 */
Shopify.getProducts = async (numProducts, queryString, cursor) => {
  var productsQuery = {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_ACCESS_TOKEN
    },
    body: JSON.stringify({
      query: PRODUCTS,
      variables: { 
        numProducts: numProducts,
        queryString: queryString,
        cursor: cursor
      }
    })
  };

  return fetch(SHOPIFY_GRAPHQL_URI, productsQuery)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return Error(response.statusText);
    })
    .catch((error) => {
      return Error(error.message);
    });
};

Shopify.getAllProducts = async () => {
  var products = (await Shopify.getProducts(50, 'available_for_sale:true')).data.products;  
  var hasNextPage = products.pageInfo.hasNextPage;  
  var edges = products.edges;
  var cursor = edges[edges.length - 1].cursor;

  while (hasNextPage) {    
    products = (await Shopify.getProducts(50, 'available_for_sale:true', cursor)).data.products;
    hasNextPage = products.pageInfo.hasNextPage;
    cursor = products.edges[products.edges.length - 1].cursor;
    Array.prototype.push.apply(edges, products.edges);
  }

  return edges.map(edge => edge.node);
};

window.getParameterByName = function(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  var results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

/*
customerID - {int} - Shopify customer ID
tagsToUpdate - {string} - tags that should be added/removed from the customer record, must be a string that is a comma separated list ("thisTag,thatTag,anotherTag")
method - {string} - which operation should be performed on the tags, must be either 'add' or 'remove'
*/
function updateCustomerTags(customerID, tagsToUpdate, method) {
  if (!tagsToUpdate.length || !customerID || !method) {
    return;
  }

  fetch(`https://kf-utility.herokuapp.com/${method}-customer-tags`, {
    method: "POST",
    body: JSON.stringify({
      id: customerID,
      tags: tagsToUpdate,
    }),
  })
    .then((resp) => {
      if (!resp.ok) {
        throw Error(resp.statusText);
      }
      return resp.json();
    })
    .catch((err) => {
      console.log("err is ", err);
    });
}

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace(
    "supports-no-cookies",
    "supports-cookies"
  );
}

// open/close search bar in header
$("#search-expand-btn i").on("click", () => {
  $("body").addClass("js-drawer-open-top");
  $("#bc-sf-search-box-0").focus();
  dataLayer.push({
    event: "Search Open",
    eventCategory: "Search",
    eventAction: "Open",
  });
});

$("#SearchDrawer .js-drawer-close").on("click", () => {
  $("body").removeClass("js-drawer-open-top");
  document.getElementById("searchBoxContainer").style.top = "-1020px";
});

$(document).on("click", (evt) => {
  if (
    $(evt.target).is("#search-expand-btn") ||
    $(evt.target)
      .parent()
      .is("#search-expand-btn") ||
    $(evt.target).is(".js-mobile-nav-toggle") ||
    $(evt.target)
      .parent()
      .is(".js-mobile-nav-toggle") ||
    $(evt.target)
      .parents()
      .is("#mobile-nav-wrapper") ||
    $(evt.target)
      .parents()
      .is("#SearchDrawer")
  ) {
    return;
  }
  document.getElementById("searchBoxContainer").style.top = "-1020px";
  $("body")
    .removeClass("js-drawer-open-top")
    .css("overflow-y", "visible");
  $(".mobile-nav-wrapper").removeClass("open");
  $(".transparentBG").removeClass("open");
  $("#shopify-section-sidecart").removeClass("open");
});

// prevent click on top-level links for first click
// open and close mega menus
window.removeAllActiveMegaMenus = function() {
  setTimeout(() => {
    $(".dropdown-active").removeClass("dropdown-active");
  }, 200);
};

function openMegaMenuMobile(event, clickedLink) {
  if ($(event.target).hasClass("fa-minus")) {
    event.preventDefault();
    return window.removeAllActiveMegaMenus();
  }

  if (
    $(event.target).hasClass("child") ||
    $(event.target).hasClass("dropdown-active") ||
    $(event.target)
      .parent()
      .hasClass("dropdown-active") ||
    $(event.target).hasClass("gripsLink")
  ) {
    return false;
  }

  event.preventDefault();
  window.removeAllActiveMegaMenus();

  setTimeout(() => {
    var theParent = $(`.${clickedLink}`);
    theParent.addClass("dropdown-active");
  }, 200);

  return false;
}

window.openMobileMegaMenu = function(event, clickedLink) {
  openMegaMenuMobile(event, clickedLink);
};

window.closeEverything = function() {
  $("#mobile-nav-wrapper").removeClass("open");
  $("#transparentBG").removeClass("open");
  $("body").removeClass("sidecart-open");
  $("body,html").css("position", "unset");
};

// Open/Close mobile menu
window.toggleMobileNav = function() {
  if ($(".mobile-nav-wrapper").hasClass("open") === false) {
    $("#mobile-nav-wrapper").addClass("open");
    $("#transparentBG").addClass("open");
    $("body,html").css("position", "fixed");
  } else {
    $("#mobile-nav-wrapper").removeClass("open");
    $("#transparentBG").removeClass("open");
    $("body,html").css("position", "unset");
  }
};

window.hideQuadPayOrNot = function(country) {
  if (country !== "United States" && country !== "US") {
    $(".quadPayWidget").css("display", "none");
  }
};

// variant stuff
window.updateVariant = function(
  optionValue,
  optionIndex,
  productVariants,
  productID,
  mobilePDP
) {
  var form = $(`#${productID}`);
  var foundMatch = false;

  form.find(`[data-full-value="${optionValue}"]`)[0].checked = true;

  // If product has color variants
  if (productVariants[0].option2 && productVariants[0].option2.length) {
    var option1 = form.find(`[data-option-index="0"]`)[0];
    var option1Val;
    var option2 = form.find(`[data-option-index="1"]`)[0];
    var option2Val;

    if (option1) {
      option1Val = $(option1)
        .find(":checked")
        .data("full-value");
    }

    if (option2) {
      option2Val = $(option2)
        .find(":checked")
        .data("full-value");
    }

    if (option1Val && option2Val) {
      form.find(":button").attr("disabled", false);
      var fullVal = `${option1Val} / ${option2Val}`;
      productVariants.forEach((variant, index) => {
        if (variant.title === fullVal) {
          if (variant.available) {
            if (
              mobilePDP &&
              form.find(".klaviyo-bis-trigger").css("display") !== "none"
            ) {
              setAsAvailable(form, mobilePDP);
            } else if (
              form.find("[data-add-to-cart] [data-add-to-cart-text]").text() ===
              "Unavailable"
            ) {
              setAsAvailable(form, mobilePDP);
            }
            foundMatch = true;
            $('select[name="id"]').val(variant.id);
          } else {
            setAsUnavailable(form, mobilePDP);
          }
        } else if (
          !foundMatch &&
          variant.title !== fullVal &&
          index + 1 === productVariants.length
        ) {
          setAsUnavailable(form, mobilePDP);
        }
      });
    }
  } else {
    form.find(":button").attr("disabled", false);
    productVariants.forEach((variant, index) => {
      if (variant.title === optionValue) {
        if (variant.available) {
          if (
            mobilePDP &&
            form.find(".klaviyo-bis-trigger").css("display") !== "none"
          ) {
            setAsAvailable(form, mobilePDP);
          } else if (
            form.find("[data-add-to-cart] [data-add-to-cart-text]").text() ===
            "Unavailable"
          ) {
            setAsAvailable(form, mobilePDP);
          }
          foundMatch = true;
          $('select[name="id"]').val(variant.id);
        } else {
          setAsUnavailable(form, mobilePDP);
        }
      } else if (
        !foundMatch &&
        variant.title !== optionValue &&
        index + 1 === productVariants.length
      ) {
        setAsUnavailable(form, mobilePDP);
      }
    });
  }

  form
    .find(".single-option-selector")
    .eq(optionIndex)
    .val(optionValue)
    .trigger("change");
};

function setAsUnavailable(form, mobilePDP) {
  if (mobilePDP) {
    form
      .find("[data-add-to-cart]")
      .attr("disabled", true)
      .css("display", "none");
    form.find(".klaviyo-bis-trigger").css("display", "block");
  } else {
    form
      .find("[data-add-to-cart]")
      .attr("disabled", true)
      .css("opacity", ".7");
    form.find("[data-add-to-cart] [data-add-to-cart-text]").text("Unavailable");
  }
}

function setAsAvailable(form, mobilePDP) {
  if (mobilePDP) {
    form
      .find("[data-add-to-cart]")
      .attr("disabled", false)
      .css("display", "block");
    form.find(".klaviyo-bis-trigger").css("display", "none");
  } else {
    form
      .find("[data-add-to-cart]")
      .attr("disabled", false)
      .css("opacity", 1);
    form.find("[data-add-to-cart] [data-add-to-cart-text]").text("Add To Cart");
  }
}

// open modal
window.openModal = function(chosenModal) {
  $(`${chosenModal} .light-modal-content`).addClass("animated slideInUp");
  $("body,html").css("position", "fixed");
  $(chosenModal).addClass("visible");
  setTimeout(() => {
    $(`${chosenModal} .light-modal-content`).removeClass("animated slideInUp");
  }, 500);
};

// close modal
window.closeModal = function(chosenModal) {
  $(`${chosenModal} .light-modal-content`).addClass("animated slideOutDown");

  setTimeout(() => {
    $(chosenModal).removeClass("visible");
    $("body,html").css("position", "unset");
    $(`${chosenModal} .light-modal-content`).removeClass(
      "animated slideOutDown"
    );
  }, 500);
};

window.scrollToTop = function() {
  $("html, body").animate(
    {
      scrollTop: 0,
    },
    800
  );
};
$(() => {
  var challengePage = window.location.href.indexOf("/challenge#");
  if (challengePage > 0) {
    $(".captchaTxt").fadeIn(800);
  }
});

// remove the loader when the page is done
function removeLoader() {
  var loader = document.getElementById("pacman-loader");  
  loader.style.opacity = "0";
  loader.style.display = "none";
}

window.addEventListener("load", () => {

  // Add a keyup event listener to our input element
  var searchInput = document.getElementById("bc-sf-search-box-0");

  searchInput.addEventListener("keyup", (event) => {
    searchSuggest(event);
  });

  // create one global XHR object
  // so we can abort old requests when a new one is make
  window.searchSuggestXHR = new XMLHttpRequest();
});

window.lastSearch = [];

// Autocomplete for form
function searchSuggest(event) {
  var searchResults = 5;
  var searchQuery = event.target.value;
  var searchBoxContainer = document.getElementById("searchBoxContainer");
  var searchBox = document.getElementById("searchBox");

  if (window.screen.height < 580) {
    searchResults = 4;
  }
  if (window.screen.height < 485) {
    searchResults = 3;
  }
  if (window.screen.height < 400) {
    searchResults = 2;
  }

  if (
    event.target.value.length >= 1 &&
    !!searchQuery.replace(/\s/g, "").length
  ) {
    // abort any pending requests
    window.searchSuggestXHR.abort();

    window.searchSuggestXHR.onreadystatechange = function() {
      if (this.readyState !== 4 || this.status !== 200) {
        return false;
      }

      var response = JSON.parse(this.responseText);
      var products = response.resources.results.products;
      var productIds = [];

      if (products.length) {
        products.forEach((product) => {
          productIds.push(product.id);
        });

        var productsJSON = JSON.stringify(productIds);

        if (window.lastSearch === productsJSON) {
          return false;
        }

        window.lastSearch = productsJSON;

        searchBox.innerHTML = "";

        products.forEach((product) => {
          if (product.type !== "Promo Item") {
            var li = document.createElement("li");
            var image = product.image.replace(".jpg", "_small.jpg");
            li.setAttribute("id", product.handle);
            li.innerHTML = `
              <a href="/products/${product.handle}" onclick="dataLayer.push({
                'event': 'Search Click',
                'eventCategory': 'Search',
                'eventAction': 'Click',
                'eventLabel': '${product.title}'
              });">
                <img class="productImage ${image_tag_custom_classes}" data-src="${image}">
                <span class="productTitle">${product.title}</span>
              </a>`;
            searchBox.appendChild(li);
          }
        });
        searchBoxContainer.style.top = "20px";
      } else {
        searchBoxContainer.style.top = "-1020px";
      }
      return true;
    };

    var qs =
      `?s=${searchQuery}` +
      `&resources[types][]=product` +
      `&resources[limit]=${searchResults}` +
      `&resources[options][unavailable_products]=bury` +
      `&resources[options][fields]=title`;

    window.searchSuggestXHR.open("GET", `/search/suggest.json${qs}`, true);
    window.searchSuggestXHR.send();
  } else {
    searchBoxContainer.style.top = "-1020px";
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  removeLoader();

  var countryIsoCode = window.getCookie("country_iso_code");

  if (countryIsoCode) {
    if (countryIsoCode !== "US") {
      $(".quadPayWidget").css("display", "none");
    }
  } else {
    fetch(`https://kf-utility.herokuapp.com/geolocate`, {
      method: "GET",
    })
    .then((resp) => {
      if (!resp.ok) {
        throw Error(resp.statusText);
      }

      return resp.json();
    })
    .then((resp) => {
      window.locationData = resp;
      window.setCookie("country_iso_code", resp.country_iso_code, 90);
      window.setCookie("continent_code", resp.continent_code, 90);
      
      if (resp.country_iso_code !== "US") {
        $(".quadPayWidget").css("display", "none");
      }
    })
    .catch((err) => {
      console.log("err is ", err);
    });
  }
});